<div *ngIf="canAccess" class="relative dashboard-box lg:col-span-2 ">
  <div class="absolute inset-px rounded-[16px]"></div>
  <div class="relative flex h-full flex-col overflow-hidden rounded-[16px]">

    <div class="px-8 sm:px-10 py-1 flex content-center dashboard-header">
      <h2 class="text-xl text-white font-semibold w-fit mb-0">Usuarios</h2>
    </div>

    <div class="@container relative min-h-[15rem] w-full grow max-lg:mx-auto max-lg:max-w-sm px-2 lg:px-8">
      <div class="flex mt-6 mb-6 inset-x-0 bottom-0">
        <div *ngIf="loadingUsers" class="w-full text-center">
          <mat-spinner diameter="50" strokeWidth="3"></mat-spinner>
        </div>

        <app-generic-list class="w-full flex-col" *ngIf="userList.length > 0 && !loadingUsers"
          filterKeyPrefix="users"
          [items]="userList"
          (itemClick)="onUserClick($event)"
          [filterFields]="filterUsers"
          [showFilters]="true"
          [isFiltersCollapsed]="true"
          [allowDownload]="false"
          (filtersChanged)="onFiltersChanged($event)"
          (pageChanged)="loadMoreUsers()"
          (filteredCount)="filteredCounts.userList = $event"
          [pageSize]="10">

          <ng-template #tableHeaderTemplate>
            <div class="flex items-center border-b py-2 font-semibold text-sm text-gray-700">
              <div class="w-[150px] truncate text-gray-500 mr-4">{{ "COMPONENTS.TABS.BACK.Name" | translate }}</div>
              <div class="w-[130px] truncate text-gray-500 mr-4">{{ "COMPONENTS.TABS.BACK.Phone" | translate }}</div>
              <div class="w-[200px] truncate text-gray-500 mr-4">{{ "COMPONENTS.TABS.BACK.Email" | translate }}</div>
              <div class="w-[120px] truncate text-gray-500 mr-4">Entorno</div>
              <div class="w-[120px] truncate text-gray-500 mr-4">Portal</div>
              <div class="w-[120px] truncate text-gray-500 mr-4">Estado</div>
              <div class="w-[110px] truncate text-gray-500">Fecha alta</div>
            </div>
          </ng-template>

          <ng-template #itemTemplate let-item>
            <div class="flex items-center border-b py-2 text-sm overflow-x-auto">
              <div class="w-[150px] truncate overflow-hidden whitespace-nowrap font-bold mr-4" title="{{ item.fullname }}">{{ item.fullname }}</div>
              <div class="w-[130px] truncate overflow-hidden whitespace-nowrap text-gray-500 mr-4" title="{{ item.phone_number }}">{{ item.phone_number }}</div>
              <div class="w-[200px] truncate overflow-hidden whitespace-nowrap text-gray-500 mr-4" title="{{ item.email }}">{{ item.email }}</div>
              <div class="w-[120px] truncate overflow-hidden whitespace-nowrap text-gray-500 mr-4" title="{{ item['custom:allowed_envs'] }}">{{ item['custom:allowed_envs'] }}</div>
              <div class="w-[120px] truncate overflow-hidden whitespace-nowrap text-gray-500 mr-4" title="{{ item['custom:Portal'] }}">{{ item['custom:Portal'] }}</div>
              <div class="w-[120px] truncate overflow-hidden whitespace-nowrap mr-4">{{ item.UserStatus }}</div>
              <div class="w-[110px] truncate overflow-hidden whitespace-nowrap" *ngIf="item.UserCreateDate">{{ item.UserCreateDate | date:'dd/MM/yyyy' }}
              </div>
            </div>
          </ng-template>


          <div *ngIf="filteredCounts.userList == 0 && !loadingUsers" class="w-full content-center h-[200px]">
            <div class="!font-medium text-center">
              <mat-icon class="!text-[100px] !size-[100px]" style="color:#cfcfcf;">people</mat-icon><br />
              No se encontraron usuarios
            </div>
          </div>
        </app-generic-list>

        </div>
    </div>



    <button mat-button color="primary" (click)="onNewUser()">{{'COMPONENTS.PROFILE.CREATE' | translate }} </button>

  <div class="pointer-events-none absolute inset-px rounded-lg ring-1 shadow-sm ring-black/5 lg:rounded-[2rem]"></div>
</div>
